var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyBack = function SvgMoneyBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#money-back_svg__a)",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9 23.446c0 1.06 1.25 1.922 2.625 1.922s2.625-.861 2.625-1.922c0-2.845-5.25-.997-5.25-3.853 0-1.06 1.25-1.922 2.625-1.922s2.625.861 2.625 1.922M21.525 15.75v1.922M21.525 25.378V27.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.525 30.975a9.45 9.45 0 1 0 0-18.9 9.45 9.45 0 0 0 0 18.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.087 11.025c3.245-4.452 8.505-7.35 14.438-7.35 9.86 0 17.85 7.99 17.85 17.85 0 9.86-7.99 17.85-17.85 17.85-9.86 0-17.85-7.99-17.85-17.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.175 11.025h-7.35v-7.35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "money-back_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
};
export default SvgMoneyBack;